export default __webpack_public_path__ + "static/media/ticongle-bootcamp.5f6d0f66.png";